// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/user/v1/attribute.proto" (package "c1.api.user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest
 */
export interface UserAttributeManagementServiceListAttributeTypesRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigApp
 */
export interface UserAttributeTypeConfigApp {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigAppUserProfile
 */
export interface UserAttributeTypeConfigAppUserProfile {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 2
     */
    appUserProfileAttributeKey: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile
 */
export interface UserAttributeTypeConfigCustomAppUserProfile {
    /**
     * @generated from protobuf field: string user_profile_attribute_key = 1
     */
    userProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 3
     */
    appUserProfileAttributeKey: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeTypeConfigCelExpression
 */
export interface UserAttributeTypeConfigCelExpression {
    /**
     * @generated from protobuf field: string user_profile_attribute_key = 1
     */
    userProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string cel_expression = 2
     */
    celExpression: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeType
 */
export interface UserAttributeType {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "app";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigApp app = 100
         */
        app: UserAttributeTypeConfigApp;
    } | {
        oneofKind: "appUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101
         */
        appUserProfile: UserAttributeTypeConfigAppUserProfile;
    } | {
        oneofKind: "customAppUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile custom_app_user_profile = 102
         */
        customAppUserProfile: UserAttributeTypeConfigCustomAppUserProfile;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 103
         */
        celExpression: UserAttributeTypeConfigCelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingFallback
 */
export interface UserAttributeMappingFallback {
    /**
     * @generated from protobuf oneof: fallback
     */
    fallback: {
        oneofKind: "app";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigApp app = 100
         */
        app: UserAttributeTypeConfigApp;
    } | {
        oneofKind: "appUserProfile";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101
         */
        appUserProfile: UserAttributeTypeConfigAppUserProfile;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 102
         */
        celExpression: UserAttributeTypeConfigCelExpression;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse
 */
export interface UserAttributeManagementServiceListAttributeTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeType list = 1
     */
    list: UserAttributeType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListRequest
 */
export interface UserAttributeManagementServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3
     */
    expandMask?: UserAttributeMapConfigExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceListResponse
 */
export interface UserAttributeManagementServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingView list = 1
     */
    list: UserAttributeMappingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMapping
 */
export interface UserAttributeMapping {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 3
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 count = 7
     */
    count: number;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 8
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: uint32 priority = 9
     */
    priority: number;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 10
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: int32 evaluation_error_count = 11
     */
    evaluationErrorCount: number;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingView
 */
export interface UserAttributeMappingView {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping user_attribute_mapping = 1
     */
    userAttributeMapping?: UserAttributeMapping;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string fallbacks_path = 3
     */
    fallbacksPath: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingRef
 */
export interface UserAttributeMappingRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingErrorLog
 */
export interface UserAttributeMappingErrorLog {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: string error = 3
     */
    error: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceGetRequest
 */
export interface UserAttributeManagementServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 2
     */
    expandMask?: UserAttributeMapConfigExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceGetResponse
 */
export interface UserAttributeManagementServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMapConfigExpandMask
 */
export interface UserAttributeMapConfigExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateRequest
 */
export interface UserAttributeManagementServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 2
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 5
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 4
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 6
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 7
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateResponse
 */
export interface UserAttributeManagementServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest
 */
export interface UserAttributeManagementServiceUpdateDisplayNameRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse
 */
export interface UserAttributeManagementServiceUpdateDisplayNameResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping attribute = 1
     */
    attribute?: UserAttributeMapping;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteRequest
 */
export interface UserAttributeManagementServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteResponse
 */
export interface UserAttributeManagementServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateRequest
 */
export interface UserAttributeManagementServiceUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeType attribute_type = 2
     */
    attributeType?: UserAttributeType;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 4
     */
    fallbacks: UserAttributeMappingFallback[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 5
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateResponse
 */
export interface UserAttributeManagementServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingView attribute = 1
     */
    attribute?: UserAttributeMappingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchRequest
 */
export interface UserAttributeSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchResponse
 */
export interface UserAttributeSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMapping list = 1
     */
    list: UserAttributeMapping[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest
 */
export interface UserAttributeSearchServiceSearchMappingsRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string display_names = 2
     */
    displayNames: string[];
    /**
     * @generated from protobuf field: repeated string app_user_profile_attribute_keys = 3
     */
    appUserProfileAttributeKeys: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4
     */
    appIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 5
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 7
     */
    expandMask?: UserAttributeMapConfigExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingRef refs = 8
     */
    refs: UserAttributeMappingRef[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse
 */
export interface UserAttributeSearchServiceSearchMappingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingView list = 1
     */
    list: UserAttributeMappingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest
 */
export interface UserAttributeSearchServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest search = 1
     */
    search?: UserAttributeSearchServiceSearchMappingsRequest;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType term = 2
     */
    term: UserAttributeSearchServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType
 */
export enum UserAttributeSearchServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DISPLAY_NAMES = 1;
     */
    DISPLAY_NAMES = 1,
    /**
     * @generated from protobuf enum value: APP_IDS = 2;
     */
    APP_IDS = 2
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse
 */
export interface UserAttributeSearchServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewRequest
 */
export interface UserAttributeManagementServicePreviewRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserAttributeMapping mapping = 1
     */
    mapping?: UserAttributeMapping;
    /**
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated string profile_type_ids = 3
     */
    profileTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult
 */
export interface UserAttributeMappingPreviewResult {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string username = 2
     */
    username: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @deprecated
     * @generated from protobuf field: string calculated_value = 4 [deprecated = true]
     */
    calculatedValue: string;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 100
         */
        stringValue: string;
    } | {
        oneofKind: "stringValues";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues string_values = 101
         */
        stringValues: UserAttributeMappingPreviewResult_StringValues;
    } | {
        oneofKind: "users";
        /**
         * @generated from protobuf field: c1.api.user.v1.UserAttributeMappingPreviewResult.Users users = 102
         */
        users: UserAttributeMappingPreviewResult_Users;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string error_message = 5
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues
 */
export interface UserAttributeMappingPreviewResult_StringValues {
    /**
     * @generated from protobuf field: repeated string values = 1
     */
    values: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users
 */
export interface UserAttributeMappingPreviewResult_Users {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User values = 1
     */
    values: UserAttributeMappingPreviewResult_Users_User[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User
 */
export interface UserAttributeMappingPreviewResult_Users_User {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string username = 2
     */
    username: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewResponse
 */
export interface UserAttributeManagementServicePreviewResponse {
    /**
     * @deprecated
     * @generated from protobuf field: repeated string preview = 1 [deprecated = true]
     */
    preview: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingPreviewResult results = 2
     */
    results: UserAttributeMappingPreviewResult[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest
 */
export interface UserAttributeSearchServiceSearchErrorLogsRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse
 */
export interface UserAttributeSearchServiceSearchErrorLogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingErrorLog list = 1
     */
    list: UserAttributeMappingErrorLog[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListAttributeTypesRequest$Type extends MessageType<UserAttributeManagementServiceListAttributeTypesRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest", []);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceListAttributeTypesRequest>): UserAttributeManagementServiceListAttributeTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceListAttributeTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceListAttributeTypesRequest): UserAttributeManagementServiceListAttributeTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceListAttributeTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesRequest
 */
export const UserAttributeManagementServiceListAttributeTypesRequest = new UserAttributeManagementServiceListAttributeTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigApp$Type extends MessageType<UserAttributeTypeConfigApp> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigApp", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeTypeConfigApp>): UserAttributeTypeConfigApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeTypeConfigApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeTypeConfigApp): UserAttributeTypeConfigApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeTypeConfigApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigApp
 */
export const UserAttributeTypeConfigApp = new UserAttributeTypeConfigApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigAppUserProfile$Type extends MessageType<UserAttributeTypeConfigAppUserProfile> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigAppUserProfile", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeTypeConfigAppUserProfile>): UserAttributeTypeConfigAppUserProfile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserProfileAttributeKey = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeTypeConfigAppUserProfile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeTypeConfigAppUserProfile): UserAttributeTypeConfigAppUserProfile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_profile_attribute_key */ 2:
                    message.appUserProfileAttributeKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeTypeConfigAppUserProfile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_profile_attribute_key = 2; */
        if (message.appUserProfileAttributeKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserProfileAttributeKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigAppUserProfile
 */
export const UserAttributeTypeConfigAppUserProfile = new UserAttributeTypeConfigAppUserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigCustomAppUserProfile$Type extends MessageType<UserAttributeTypeConfigCustomAppUserProfile> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile", [
            { no: 1, name: "user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeTypeConfigCustomAppUserProfile>): UserAttributeTypeConfigCustomAppUserProfile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userProfileAttributeKey = "";
        message.appId = "";
        message.appUserProfileAttributeKey = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeTypeConfigCustomAppUserProfile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeTypeConfigCustomAppUserProfile): UserAttributeTypeConfigCustomAppUserProfile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_profile_attribute_key */ 1:
                    message.userProfileAttributeKey = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_user_profile_attribute_key */ 3:
                    message.appUserProfileAttributeKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeTypeConfigCustomAppUserProfile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_profile_attribute_key = 1; */
        if (message.userProfileAttributeKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userProfileAttributeKey);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_user_profile_attribute_key = 3; */
        if (message.appUserProfileAttributeKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserProfileAttributeKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile
 */
export const UserAttributeTypeConfigCustomAppUserProfile = new UserAttributeTypeConfigCustomAppUserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeTypeConfigCelExpression$Type extends MessageType<UserAttributeTypeConfigCelExpression> {
    constructor() {
        super("c1.api.user.v1.UserAttributeTypeConfigCelExpression", [
            { no: 1, name: "user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cel_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeTypeConfigCelExpression>): UserAttributeTypeConfigCelExpression {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userProfileAttributeKey = "";
        message.celExpression = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeTypeConfigCelExpression>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeTypeConfigCelExpression): UserAttributeTypeConfigCelExpression {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_profile_attribute_key */ 1:
                    message.userProfileAttributeKey = reader.string();
                    break;
                case /* string cel_expression */ 2:
                    message.celExpression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeTypeConfigCelExpression, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_profile_attribute_key = 1; */
        if (message.userProfileAttributeKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userProfileAttributeKey);
        /* string cel_expression = 2; */
        if (message.celExpression !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.celExpression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeTypeConfigCelExpression
 */
export const UserAttributeTypeConfigCelExpression = new UserAttributeTypeConfigCelExpression$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeType$Type extends MessageType<UserAttributeType> {
    constructor() {
        super("c1.api.user.v1.UserAttributeType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "app", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigApp },
            { no: 101, name: "app_user_profile", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigAppUserProfile },
            { no: 102, name: "custom_app_user_profile", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigCustomAppUserProfile },
            { no: 103, name: "cel_expression", kind: "message", oneof: "config", T: () => UserAttributeTypeConfigCelExpression }
        ]);
    }
    create(value?: PartialMessage<UserAttributeType>): UserAttributeType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.config = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UserAttributeType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeType): UserAttributeType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigApp app */ 100:
                    message.config = {
                        oneofKind: "app",
                        app: UserAttributeTypeConfigApp.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).app)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile */ 101:
                    message.config = {
                        oneofKind: "appUserProfile",
                        appUserProfile: UserAttributeTypeConfigAppUserProfile.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).appUserProfile)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile custom_app_user_profile */ 102:
                    message.config = {
                        oneofKind: "customAppUserProfile",
                        customAppUserProfile: UserAttributeTypeConfigCustomAppUserProfile.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).customAppUserProfile)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression */ 103:
                    message.config = {
                        oneofKind: "celExpression",
                        celExpression: UserAttributeTypeConfigCelExpression.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).celExpression)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.user.v1.UserAttributeTypeConfigApp app = 100; */
        if (message.config.oneofKind === "app")
            UserAttributeTypeConfigApp.internalBinaryWrite(message.config.app, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101; */
        if (message.config.oneofKind === "appUserProfile")
            UserAttributeTypeConfigAppUserProfile.internalBinaryWrite(message.config.appUserProfile, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeTypeConfigCustomAppUserProfile custom_app_user_profile = 102; */
        if (message.config.oneofKind === "customAppUserProfile")
            UserAttributeTypeConfigCustomAppUserProfile.internalBinaryWrite(message.config.customAppUserProfile, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 103; */
        if (message.config.oneofKind === "celExpression")
            UserAttributeTypeConfigCelExpression.internalBinaryWrite(message.config.celExpression, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeType
 */
export const UserAttributeType = new UserAttributeType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingFallback$Type extends MessageType<UserAttributeMappingFallback> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingFallback", [
            { no: 100, name: "app", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigApp },
            { no: 101, name: "app_user_profile", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigAppUserProfile },
            { no: 102, name: "cel_expression", kind: "message", oneof: "fallback", T: () => UserAttributeTypeConfigCelExpression }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingFallback>): UserAttributeMappingFallback {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fallback = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingFallback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingFallback): UserAttributeMappingFallback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeTypeConfigApp app */ 100:
                    message.fallback = {
                        oneofKind: "app",
                        app: UserAttributeTypeConfigApp.internalBinaryRead(reader, reader.uint32(), options, (message.fallback as any).app)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile */ 101:
                    message.fallback = {
                        oneofKind: "appUserProfile",
                        appUserProfile: UserAttributeTypeConfigAppUserProfile.internalBinaryRead(reader, reader.uint32(), options, (message.fallback as any).appUserProfile)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression */ 102:
                    message.fallback = {
                        oneofKind: "celExpression",
                        celExpression: UserAttributeTypeConfigCelExpression.internalBinaryRead(reader, reader.uint32(), options, (message.fallback as any).celExpression)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingFallback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeTypeConfigApp app = 100; */
        if (message.fallback.oneofKind === "app")
            UserAttributeTypeConfigApp.internalBinaryWrite(message.fallback.app, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeTypeConfigAppUserProfile app_user_profile = 101; */
        if (message.fallback.oneofKind === "appUserProfile")
            UserAttributeTypeConfigAppUserProfile.internalBinaryWrite(message.fallback.appUserProfile, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeTypeConfigCelExpression cel_expression = 102; */
        if (message.fallback.oneofKind === "celExpression")
            UserAttributeTypeConfigCelExpression.internalBinaryWrite(message.fallback.celExpression, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingFallback
 */
export const UserAttributeMappingFallback = new UserAttributeMappingFallback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListAttributeTypesResponse$Type extends MessageType<UserAttributeManagementServiceListAttributeTypesResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeType }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceListAttributeTypesResponse>): UserAttributeManagementServiceListAttributeTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceListAttributeTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceListAttributeTypesResponse): UserAttributeManagementServiceListAttributeTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeType list */ 1:
                    message.list.push(UserAttributeType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceListAttributeTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListAttributeTypesResponse
 */
export const UserAttributeManagementServiceListAttributeTypesResponse = new UserAttributeManagementServiceListAttributeTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListRequest$Type extends MessageType<UserAttributeManagementServiceListRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceListRequest>): UserAttributeManagementServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceListRequest): UserAttributeManagementServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask */ 3:
                    message.expandMask = UserAttributeMapConfigExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserAttributeMapConfigExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListRequest
 */
export const UserAttributeManagementServiceListRequest = new UserAttributeManagementServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceListResponse$Type extends MessageType<UserAttributeManagementServiceListResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceListResponse>): UserAttributeManagementServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceListResponse): UserAttributeManagementServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeMappingView list */ 1:
                    message.list.push(UserAttributeMappingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeMappingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeMappingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceListResponse
 */
export const UserAttributeManagementServiceListResponse = new UserAttributeManagementServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMapping$Type extends MessageType<UserAttributeMapping> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMapping", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 9, name: "priority", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 11, name: "evaluation_error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMapping>): UserAttributeMapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.appId = "";
        message.appUserProfileAttributeKey = "";
        message.displayName = "";
        message.count = 0;
        message.priority = 0;
        message.fallbacks = [];
        message.evaluationErrorCount = 0;
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMapping): UserAttributeMapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_user_profile_attribute_key */ 3:
                    message.appUserProfileAttributeKey = reader.string();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* int32 count */ 7:
                    message.count = reader.int32();
                    break;
                case /* c1.api.user.v1.UserAttributeType attribute_type */ 8:
                    message.attributeType = UserAttributeType.internalBinaryRead(reader, reader.uint32(), options, message.attributeType);
                    break;
                case /* uint32 priority */ 9:
                    message.priority = reader.uint32();
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks */ 10:
                    message.fallbacks.push(UserAttributeMappingFallback.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 evaluation_error_count */ 11:
                    message.evaluationErrorCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_user_profile_attribute_key = 3; */
        if (message.appUserProfileAttributeKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserProfileAttributeKey);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 count = 7; */
        if (message.count !== 0)
            writer.tag(7, WireType.Varint).int32(message.count);
        /* c1.api.user.v1.UserAttributeType attribute_type = 8; */
        if (message.attributeType)
            UserAttributeType.internalBinaryWrite(message.attributeType, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* uint32 priority = 9; */
        if (message.priority !== 0)
            writer.tag(9, WireType.Varint).uint32(message.priority);
        /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 10; */
        for (let i = 0; i < message.fallbacks.length; i++)
            UserAttributeMappingFallback.internalBinaryWrite(message.fallbacks[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 evaluation_error_count = 11; */
        if (message.evaluationErrorCount !== 0)
            writer.tag(11, WireType.Varint).int32(message.evaluationErrorCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMapping
 */
export const UserAttributeMapping = new UserAttributeMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingView$Type extends MessageType<UserAttributeMappingView> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingView", [
            { no: 1, name: "user_attribute_mapping", kind: "message", T: () => UserAttributeMapping },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fallbacks_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingView>): UserAttributeMappingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.fallbacksPath = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingView): UserAttributeMappingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMapping user_attribute_mapping */ 1:
                    message.userAttributeMapping = UserAttributeMapping.internalBinaryRead(reader, reader.uint32(), options, message.userAttributeMapping);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string fallbacks_path */ 3:
                    message.fallbacksPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMapping user_attribute_mapping = 1; */
        if (message.userAttributeMapping)
            UserAttributeMapping.internalBinaryWrite(message.userAttributeMapping, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string fallbacks_path = 3; */
        if (message.fallbacksPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fallbacksPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingView
 */
export const UserAttributeMappingView = new UserAttributeMappingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingRef$Type extends MessageType<UserAttributeMappingRef> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingRef>): UserAttributeMappingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingRef): UserAttributeMappingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingRef
 */
export const UserAttributeMappingRef = new UserAttributeMappingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingErrorLog$Type extends MessageType<UserAttributeMappingErrorLog> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingErrorLog", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingErrorLog>): UserAttributeMappingErrorLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAttributeMappingId = "";
        message.userId = "";
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingErrorLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingErrorLog): UserAttributeMappingErrorLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_attribute_mapping_id */ 1:
                    message.userAttributeMappingId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingErrorLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_attribute_mapping_id = 1; */
        if (message.userAttributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAttributeMappingId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingErrorLog
 */
export const UserAttributeMappingErrorLog = new UserAttributeMappingErrorLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceGetRequest$Type extends MessageType<UserAttributeManagementServiceGetRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceGetRequest>): UserAttributeManagementServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceGetRequest): UserAttributeManagementServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask */ 2:
                    message.expandMask = UserAttributeMapConfigExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 2; */
        if (message.expandMask)
            UserAttributeMapConfigExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceGetRequest
 */
export const UserAttributeManagementServiceGetRequest = new UserAttributeManagementServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceGetResponse$Type extends MessageType<UserAttributeManagementServiceGetResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceGetResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceGetResponse>): UserAttributeManagementServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceGetResponse): UserAttributeManagementServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMappingView attribute */ 1:
                    message.attribute = UserAttributeMappingView.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMappingView attribute = 1; */
        if (message.attribute)
            UserAttributeMappingView.internalBinaryWrite(message.attribute, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceGetResponse
 */
export const UserAttributeManagementServiceGetResponse = new UserAttributeManagementServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMapConfigExpandMask$Type extends MessageType<UserAttributeMapConfigExpandMask> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMapConfigExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "fallbacks"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMapConfigExpandMask>): UserAttributeMapConfigExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMapConfigExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMapConfigExpandMask): UserAttributeMapConfigExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMapConfigExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMapConfigExpandMask
 */
export const UserAttributeMapConfigExpandMask = new UserAttributeMapConfigExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceCreateRequest$Type extends MessageType<UserAttributeManagementServiceCreateRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 5, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 4, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 6, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 7, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceCreateRequest>): UserAttributeManagementServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserProfileAttributeKey = "";
        message.displayName = "";
        message.fallbacks = [];
        message.profileTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceCreateRequest): UserAttributeManagementServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_profile_attribute_key */ 2:
                    message.appUserProfileAttributeKey = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeType attribute_type */ 5:
                    message.attributeType = UserAttributeType.internalBinaryRead(reader, reader.uint32(), options, message.attributeType);
                    break;
                case /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask */ 4:
                    message.expandMask = UserAttributeMapConfigExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks */ 6:
                    message.fallbacks.push(UserAttributeMappingFallback.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string profile_type_ids */ 7:
                    message.profileTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_profile_attribute_key = 2; */
        if (message.appUserProfileAttributeKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserProfileAttributeKey);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 4; */
        if (message.expandMask)
            UserAttributeMapConfigExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeType attribute_type = 5; */
        if (message.attributeType)
            UserAttributeType.internalBinaryWrite(message.attributeType, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 6; */
        for (let i = 0; i < message.fallbacks.length; i++)
            UserAttributeMappingFallback.internalBinaryWrite(message.fallbacks[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string profile_type_ids = 7; */
        for (let i = 0; i < message.profileTypeIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.profileTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateRequest
 */
export const UserAttributeManagementServiceCreateRequest = new UserAttributeManagementServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceCreateResponse$Type extends MessageType<UserAttributeManagementServiceCreateResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceCreateResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceCreateResponse>): UserAttributeManagementServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceCreateResponse): UserAttributeManagementServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMappingView attribute */ 1:
                    message.attribute = UserAttributeMappingView.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMappingView attribute = 1; */
        if (message.attribute)
            UserAttributeMappingView.internalBinaryWrite(message.attribute, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceCreateResponse
 */
export const UserAttributeManagementServiceCreateResponse = new UserAttributeManagementServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateDisplayNameRequest$Type extends MessageType<UserAttributeManagementServiceUpdateDisplayNameRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceUpdateDisplayNameRequest>): UserAttributeManagementServiceUpdateDisplayNameRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceUpdateDisplayNameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceUpdateDisplayNameRequest): UserAttributeManagementServiceUpdateDisplayNameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceUpdateDisplayNameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameRequest
 */
export const UserAttributeManagementServiceUpdateDisplayNameRequest = new UserAttributeManagementServiceUpdateDisplayNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateDisplayNameResponse$Type extends MessageType<UserAttributeManagementServiceUpdateDisplayNameResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMapping }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceUpdateDisplayNameResponse>): UserAttributeManagementServiceUpdateDisplayNameResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceUpdateDisplayNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceUpdateDisplayNameResponse): UserAttributeManagementServiceUpdateDisplayNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMapping attribute */ 1:
                    message.attribute = UserAttributeMapping.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceUpdateDisplayNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMapping attribute = 1; */
        if (message.attribute)
            UserAttributeMapping.internalBinaryWrite(message.attribute, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateDisplayNameResponse
 */
export const UserAttributeManagementServiceUpdateDisplayNameResponse = new UserAttributeManagementServiceUpdateDisplayNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceDeleteRequest$Type extends MessageType<UserAttributeManagementServiceDeleteRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceDeleteRequest>): UserAttributeManagementServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceDeleteRequest): UserAttributeManagementServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteRequest
 */
export const UserAttributeManagementServiceDeleteRequest = new UserAttributeManagementServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceDeleteResponse$Type extends MessageType<UserAttributeManagementServiceDeleteResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceDeleteResponse>): UserAttributeManagementServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceDeleteResponse): UserAttributeManagementServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceDeleteResponse
 */
export const UserAttributeManagementServiceDeleteResponse = new UserAttributeManagementServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateRequest$Type extends MessageType<UserAttributeManagementServiceUpdateRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "attribute_type", kind: "message", T: () => UserAttributeType },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 4, name: "fallbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingFallback },
            { no: 5, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceUpdateRequest>): UserAttributeManagementServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.fallbacks = [];
        message.profileTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceUpdateRequest): UserAttributeManagementServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeType attribute_type */ 2:
                    message.attributeType = UserAttributeType.internalBinaryRead(reader, reader.uint32(), options, message.attributeType);
                    break;
                case /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask */ 3:
                    message.expandMask = UserAttributeMapConfigExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks */ 4:
                    message.fallbacks.push(UserAttributeMappingFallback.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string profile_type_ids */ 5:
                    message.profileTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.user.v1.UserAttributeType attribute_type = 2; */
        if (message.attributeType)
            UserAttributeType.internalBinaryWrite(message.attributeType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 3; */
        if (message.expandMask)
            UserAttributeMapConfigExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserAttributeMappingFallback fallbacks = 4; */
        for (let i = 0; i < message.fallbacks.length; i++)
            UserAttributeMappingFallback.internalBinaryWrite(message.fallbacks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string profile_type_ids = 5; */
        for (let i = 0; i < message.profileTypeIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.profileTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateRequest
 */
export const UserAttributeManagementServiceUpdateRequest = new UserAttributeManagementServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServiceUpdateResponse$Type extends MessageType<UserAttributeManagementServiceUpdateResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServiceUpdateResponse", [
            { no: 1, name: "attribute", kind: "message", T: () => UserAttributeMappingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServiceUpdateResponse>): UserAttributeManagementServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServiceUpdateResponse): UserAttributeManagementServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMappingView attribute */ 1:
                    message.attribute = UserAttributeMappingView.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMappingView attribute = 1; */
        if (message.attribute)
            UserAttributeMappingView.internalBinaryWrite(message.attribute, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServiceUpdateResponse
 */
export const UserAttributeManagementServiceUpdateResponse = new UserAttributeManagementServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchRequest$Type extends MessageType<UserAttributeSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchRequest>): UserAttributeSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchRequest): UserAttributeSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchRequest
 */
export const UserAttributeSearchServiceSearchRequest = new UserAttributeSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchResponse$Type extends MessageType<UserAttributeSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMapping },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchResponse>): UserAttributeSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchResponse): UserAttributeSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeMapping list */ 1:
                    message.list.push(UserAttributeMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeMapping list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeMapping.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchResponse
 */
export const UserAttributeSearchServiceSearchResponse = new UserAttributeSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchMappingsRequest$Type extends MessageType<UserAttributeSearchServiceSearchMappingsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_profile_attribute_keys", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserAttributeMapConfigExpandMask },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingRef }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchMappingsRequest>): UserAttributeSearchServiceSearchMappingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.displayNames = [];
        message.appUserProfileAttributeKeys = [];
        message.appIds = [];
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchMappingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchMappingsRequest): UserAttributeSearchServiceSearchMappingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string display_names */ 2:
                    message.displayNames.push(reader.string());
                    break;
                case /* repeated string app_user_profile_attribute_keys */ 3:
                    message.appUserProfileAttributeKeys.push(reader.string());
                    break;
                case /* repeated string app_ids */ 4:
                    message.appIds.push(reader.string());
                    break;
                case /* int32 page_size */ 5:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 6:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask */ 7:
                    message.expandMask = UserAttributeMapConfigExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingRef refs */ 8:
                    message.refs.push(UserAttributeMappingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchMappingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string display_names = 2; */
        for (let i = 0; i < message.displayNames.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.displayNames[i]);
        /* repeated string app_user_profile_attribute_keys = 3; */
        for (let i = 0; i < message.appUserProfileAttributeKeys.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appUserProfileAttributeKeys[i]);
        /* repeated string app_ids = 4; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appIds[i]);
        /* int32 page_size = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageSize);
        /* string page_token = 6; */
        if (message.pageToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.user.v1.UserAttributeMapConfigExpandMask expand_mask = 7; */
        if (message.expandMask)
            UserAttributeMapConfigExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserAttributeMappingRef refs = 8; */
        for (let i = 0; i < message.refs.length; i++)
            UserAttributeMappingRef.internalBinaryWrite(message.refs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest
 */
export const UserAttributeSearchServiceSearchMappingsRequest = new UserAttributeSearchServiceSearchMappingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchMappingsResponse$Type extends MessageType<UserAttributeSearchServiceSearchMappingsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchMappingsResponse>): UserAttributeSearchServiceSearchMappingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchMappingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchMappingsResponse): UserAttributeSearchServiceSearchMappingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeMappingView list */ 1:
                    message.list.push(UserAttributeMappingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchMappingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeMappingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeMappingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchMappingsResponse
 */
export const UserAttributeSearchServiceSearchMappingsResponse = new UserAttributeSearchServiceSearchMappingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchTermsRequest$Type extends MessageType<UserAttributeSearchServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => UserAttributeSearchServiceSearchMappingsRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType", UserAttributeSearchServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchTermsRequest>): UserAttributeSearchServiceSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchTermsRequest): UserAttributeSearchServiceSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest search */ 1:
                    message.search = UserAttributeSearchServiceSearchMappingsRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeSearchServiceSearchMappingsRequest search = 1; */
        if (message.search)
            UserAttributeSearchServiceSearchMappingsRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsRequest
 */
export const UserAttributeSearchServiceSearchTermsRequest = new UserAttributeSearchServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchTermsResponse$Type extends MessageType<UserAttributeSearchServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchTermsResponse>): UserAttributeSearchServiceSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchTermsResponse): UserAttributeSearchServiceSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchTermsResponse
 */
export const UserAttributeSearchServiceSearchTermsResponse = new UserAttributeSearchServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServicePreviewRequest$Type extends MessageType<UserAttributeManagementServicePreviewRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServicePreviewRequest", [
            { no: 1, name: "mapping", kind: "message", T: () => UserAttributeMapping },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "20", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 3, name: "profile_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServicePreviewRequest>): UserAttributeManagementServicePreviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        message.profileTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServicePreviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServicePreviewRequest): UserAttributeManagementServicePreviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.UserAttributeMapping mapping */ 1:
                    message.mapping = UserAttributeMapping.internalBinaryRead(reader, reader.uint32(), options, message.mapping);
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                case /* repeated string profile_type_ids */ 3:
                    message.profileTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServicePreviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.UserAttributeMapping mapping = 1; */
        if (message.mapping)
            UserAttributeMapping.internalBinaryWrite(message.mapping, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        /* repeated string profile_type_ids = 3; */
        for (let i = 0; i < message.profileTypeIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.profileTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewRequest
 */
export const UserAttributeManagementServicePreviewRequest = new UserAttributeManagementServicePreviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult$Type extends MessageType<UserAttributeMappingPreviewResult> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "calculated_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "string_values", kind: "message", oneof: "value", T: () => UserAttributeMappingPreviewResult_StringValues },
            { no: 102, name: "users", kind: "message", oneof: "value", T: () => UserAttributeMappingPreviewResult_Users },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingPreviewResult>): UserAttributeMappingPreviewResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.username = "";
        message.displayName = "";
        message.calculatedValue = "";
        message.value = { oneofKind: undefined };
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingPreviewResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingPreviewResult): UserAttributeMappingPreviewResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string calculated_value = 4 [deprecated = true] */ 4:
                    message.calculatedValue = reader.string();
                    break;
                case /* string string_value */ 100:
                    message.value = {
                        oneofKind: "stringValue",
                        stringValue: reader.string()
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues string_values */ 101:
                    message.value = {
                        oneofKind: "stringValues",
                        stringValues: UserAttributeMappingPreviewResult_StringValues.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).stringValues)
                    };
                    break;
                case /* c1.api.user.v1.UserAttributeMappingPreviewResult.Users users */ 102:
                    message.value = {
                        oneofKind: "users",
                        users: UserAttributeMappingPreviewResult_Users.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).users)
                    };
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingPreviewResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string calculated_value = 4 [deprecated = true]; */
        if (message.calculatedValue !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.calculatedValue);
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        /* string string_value = 100; */
        if (message.value.oneofKind === "stringValue")
            writer.tag(100, WireType.LengthDelimited).string(message.value.stringValue);
        /* c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues string_values = 101; */
        if (message.value.oneofKind === "stringValues")
            UserAttributeMappingPreviewResult_StringValues.internalBinaryWrite(message.value.stringValues, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UserAttributeMappingPreviewResult.Users users = 102; */
        if (message.value.oneofKind === "users")
            UserAttributeMappingPreviewResult_Users.internalBinaryWrite(message.value.users, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult
 */
export const UserAttributeMappingPreviewResult = new UserAttributeMappingPreviewResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_StringValues$Type extends MessageType<UserAttributeMappingPreviewResult_StringValues> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingPreviewResult_StringValues>): UserAttributeMappingPreviewResult_StringValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingPreviewResult_StringValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingPreviewResult_StringValues): UserAttributeMappingPreviewResult_StringValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string values */ 1:
                    message.values.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingPreviewResult_StringValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string values = 1; */
        for (let i = 0; i < message.values.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.values[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.StringValues
 */
export const UserAttributeMappingPreviewResult_StringValues = new UserAttributeMappingPreviewResult_StringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_Users$Type extends MessageType<UserAttributeMappingPreviewResult_Users> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.Users", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingPreviewResult_Users_User }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingPreviewResult_Users>): UserAttributeMappingPreviewResult_Users {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingPreviewResult_Users>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingPreviewResult_Users): UserAttributeMappingPreviewResult_Users {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User values */ 1:
                    message.values.push(UserAttributeMappingPreviewResult_Users_User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingPreviewResult_Users, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User values = 1; */
        for (let i = 0; i < message.values.length; i++)
            UserAttributeMappingPreviewResult_Users_User.internalBinaryWrite(message.values[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users
 */
export const UserAttributeMappingPreviewResult_Users = new UserAttributeMappingPreviewResult_Users$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingPreviewResult_Users_User$Type extends MessageType<UserAttributeMappingPreviewResult_Users_User> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeMappingPreviewResult_Users_User>): UserAttributeMappingPreviewResult_Users_User {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.username = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeMappingPreviewResult_Users_User>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeMappingPreviewResult_Users_User): UserAttributeMappingPreviewResult_Users_User {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeMappingPreviewResult_Users_User, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingPreviewResult.Users.User
 */
export const UserAttributeMappingPreviewResult_Users_User = new UserAttributeMappingPreviewResult_Users_User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeManagementServicePreviewResponse$Type extends MessageType<UserAttributeManagementServicePreviewResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeManagementServicePreviewResponse", [
            { no: 1, name: "preview", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingPreviewResult }
        ]);
    }
    create(value?: PartialMessage<UserAttributeManagementServicePreviewResponse>): UserAttributeManagementServicePreviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.preview = [];
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial<UserAttributeManagementServicePreviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeManagementServicePreviewResponse): UserAttributeManagementServicePreviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string preview = 1 [deprecated = true] */ 1:
                    message.preview.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserAttributeMappingPreviewResult results */ 2:
                    message.results.push(UserAttributeMappingPreviewResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeManagementServicePreviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string preview = 1 [deprecated = true]; */
        for (let i = 0; i < message.preview.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.preview[i]);
        /* repeated c1.api.user.v1.UserAttributeMappingPreviewResult results = 2; */
        for (let i = 0; i < message.results.length; i++)
            UserAttributeMappingPreviewResult.internalBinaryWrite(message.results[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeManagementServicePreviewResponse
 */
export const UserAttributeManagementServicePreviewResponse = new UserAttributeManagementServicePreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchErrorLogsRequest$Type extends MessageType<UserAttributeSearchServiceSearchErrorLogsRequest> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchErrorLogsRequest>): UserAttributeSearchServiceSearchErrorLogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAttributeMappingId = "";
        message.query = "";
        message.userIds = [];
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchErrorLogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchErrorLogsRequest): UserAttributeSearchServiceSearchErrorLogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_attribute_mapping_id */ 1:
                    message.userAttributeMappingId = reader.string();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchErrorLogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_attribute_mapping_id = 1; */
        if (message.userAttributeMappingId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userAttributeMappingId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsRequest
 */
export const UserAttributeSearchServiceSearchErrorLogsRequest = new UserAttributeSearchServiceSearchErrorLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeSearchServiceSearchErrorLogsResponse$Type extends MessageType<UserAttributeSearchServiceSearchErrorLogsResponse> {
    constructor() {
        super("c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingErrorLog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAttributeSearchServiceSearchErrorLogsResponse>): UserAttributeSearchServiceSearchErrorLogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<UserAttributeSearchServiceSearchErrorLogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAttributeSearchServiceSearchErrorLogsResponse): UserAttributeSearchServiceSearchErrorLogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.UserAttributeMappingErrorLog list */ 1:
                    message.list.push(UserAttributeMappingErrorLog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAttributeSearchServiceSearchErrorLogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.UserAttributeMappingErrorLog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserAttributeMappingErrorLog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeSearchServiceSearchErrorLogsResponse
 */
export const UserAttributeSearchServiceSearchErrorLogsResponse = new UserAttributeSearchServiceSearchErrorLogsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserAttributeManagementService
 */
export const UserAttributeManagementService = new ServiceType("c1.api.user.v1.UserAttributeManagementService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceListRequest, O: UserAttributeManagementServiceListResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceGetRequest, O: UserAttributeManagementServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceCreateRequest, O: UserAttributeManagementServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceDeleteRequest, O: UserAttributeManagementServiceDeleteResponse },
    { name: "ListAttributeTypes", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServiceListAttributeTypesRequest, O: UserAttributeManagementServiceListAttributeTypesResponse },
    { name: "Preview", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeManagementServicePreviewRequest, O: UserAttributeManagementServicePreviewResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UserAttributeManagementServiceUpdateRequest, O: UserAttributeManagementServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserAttributeSearchService
 */
export const UserAttributeSearchService = new ServiceType("c1.api.user.v1.UserAttributeSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchRequest, O: UserAttributeSearchServiceSearchResponse },
    { name: "SearchMappings", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchMappingsRequest, O: UserAttributeSearchServiceSearchMappingsResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchTermsRequest, O: UserAttributeSearchServiceSearchTermsResponse },
    { name: "SearchErrorLogs", options: { "authz.method": { role: "VIEWER" } }, I: UserAttributeSearchServiceSearchErrorLogsRequest, O: UserAttributeSearchServiceSearchErrorLogsResponse }
]);
